import api from './client';

export type SpinToWinSegmentType = 'discount' | 'no_prize';

export interface SpinToWinSegment {
  label: string;
  type: SpinToWinSegmentType;
  discount_percent: number | null;
  weight: number;
  shopify_price_rule_id?: number | null;
}

export interface SpinToWinSettings {
  enabled: boolean;
  headline: string;
  body: string;
  button_text: string;
  trigger_delay_seconds: number;
  segments: SpinToWinSegment[];
}

export interface SpinToWinEntry {
  id: number;
  email: string;
  segment_label: string;
  discount_code: string | null;
  discount_percent: number | null;
  created_at: string | null;
}

export const MIN_SPIN_SEGMENTS = 2;
export const MAX_SPIN_SEGMENTS = 6;

export const spinToWinApi = {
  show: () =>
    api.get<{ data: { settings: SpinToWinSettings; entries_count: number } }>('/spin-to-win'),

  update: (settings: SpinToWinSettings) =>
    api.put<{ data: SpinToWinSettings }>('/spin-to-win', settings),

  entries: (page = 1) =>
    api.get<{ data: SpinToWinEntry[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/spin-to-win/entries?page=${page}`
    ),
};
